import React, { FunctionComponent, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentSection, Heading, Layout, Paragraph } from '@vwfs-bronson/bronson-react';
import { Analytics } from '../../services/analytics';
import { linkExpiredEvent } from '../../services/analytics/analyticsEvents';

export const LinkExpiredPage: FunctionComponent = () => {
  const { t } = useTranslation();

  useEffect(() => {
    Analytics.push(linkExpiredEvent);
  }, []);

  return (
    <>
      <ContentSection pageWrapSize="small">
        <Layout>
          <Layout.Item default="1/1">
            <Heading level={2}>{t('authenticate:linkExpiredTitle')}</Heading>
          </Layout.Item>
          <Layout.Item default="1/1">
            <Paragraph>{t('authenticate:linkExpiredText')}</Paragraph>
          </Layout.Item>
        </Layout>
      </ContentSection>
    </>
  );
};
